// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  mysteryKey: __t.string().primaryKey().name("mystery_key"),
  stage: __t.string(),
  postKey: __t.string().name("post_key"),
  escrowSov: __t.i64().name("escrow_sov"),
  restoredBy: __t.identity().name("restored_by"),
  restoredName: __t.string().name("restored_name"),
  choice: __t.string(),
  restoredAt: __t.timestamp().name("restored_at"),
  serviceLine: __t.string().name("service_line"),
  updatedAt: __t.timestamp().name("updated_at"),
});
